import { serviceO as axiosIns } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

/**
 * 会员的指导方案列表
 * @param {*} data 
 * @param {*} params 
 */
export function myGuidRecordList(data,params) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/findInterveneRecordList`,
        method: 'POST',
        data,
        params
    })
}

/**
 * 测评详情
 */
export function myGuidRecordDetail(params) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/queryInterveneByRecordId/${params.memberCode}/${params.recordId}`,
        method: 'GET',
        params
    })
}


// WEBPACK FOOTER //
// ./src/api/guide.js